import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function CTA() {
  return (
    <section className="py-16">
      <div className="max-w-6xl mx-auto px-6">
        <div className="relative overflow-hidden rounded-[2rem] bg-splash-coral p-10 md:p-16 text-white">
          <div className="absolute -right-24 -bottom-24 w-96 h-96 rounded-full bg-white/10" />
          <div className="absolute -right-40 -top-16 w-64 h-64 rounded-full bg-white/10" />
          <div className="relative flex flex-col md:flex-row md:items-center md:justify-between gap-8">
            <div>
              <div className="uppercase tracking-widest text-white/90 text-xs font-semibold mb-3">Limited Spots</div>
              <h3 className="font-display font-bold text-3xl md:text-4xl leading-tight max-w-xl">Save your child's spot for Winter 2026&ndash;27.</h3>
              <p className="mt-3 text-white/90 max-w-xl">Monthly memberships with small classes that fill quickly. Enrollment opens October 30, 2026.</p>
            </div>
            <div className="flex flex-wrap gap-3">
              <Link to="/enroll" className="inline-flex items-center gap-2 rounded-full bg-white text-splash-coralDark px-7 py-3.5 font-semibold btn-transition hover:bg-splash-cream">
                Enroll Now <ArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/book" className="inline-flex items-center gap-2 rounded-full bg-splash-green hover:bg-splash-greenDark text-white px-6 py-3.5 font-semibold btn-transition">
                Book a Call
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
